module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-root"
  }, [_c('div', {
    staticClass: "login-main"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "width": "900px",
      "margin": "auto"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "login-box"
  }, [_c('div', {
    staticClass: "iframe-title"
  }, [_vm._v("商家登录")]), _vm._v(" "), (_vm.loginSrc) ? _c('iframe', {
    attrs: {
      "id": "login-content-iframe",
      "src": _vm.loginSrc,
      "frameborder": "0"
    }
  }, [_vm._v("\n                    美团商家登录平台使用了框架技术，但是您的浏览器不支持框架，请升级您的浏览器以便正常访问。\n                ")]) : _vm._e()])])]), _vm._v(" "), _c('footer-bar', {
    attrs: {
      "show-mark": "true"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-container"
  }, [_c('section', {
    staticClass: "login-desc"
  }, [_c('div', {
    staticClass: "login-desc-icon"
  }, [_c('img', {
    attrs: {
      "src": "//awp-assets.meituan.net/hfe/fep/a8e56801f64e0c6261770c41ed95a679/loginlogo.svg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "login-desc-title"
  }, [_vm._v("\n                        境内度假商家中心\n                    ")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', [_vm._v("基于新美大双平台强大的流量优势")]), _vm._v(" "), _c('li', [_vm._v("一站式解决旅游商家从日常运营到渠道拓展的全部诉求")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33a6c696","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/login/Main.vue
// module id = 961
// module chunks = 0